import { AnyObject } from './types/utility'

export function parseJsonSafe<Result extends any = any>(
  json: string,
  failValue?: Result | (() => Result)
): Result {
  const getFailVal = failValue instanceof Function ? failValue : () => failValue

  if (!json) {
    return getFailVal()!
  }

  try {
    return JSON.parse(json)
  } catch (e) {
    return getFailVal()!
  }
}

export function stringifyJsonSafe(params: {
  json: AnyObject
  fallback?: string | undefined
  options?: { replacer?: (number | string)[] | null; space?: string | number }
}): string {
  const { json, options = {}, fallback = 'ERROR when stringifying json' } = params
  try {
    return JSON.stringify(json, options.replacer, options.space)
  } catch (e) {
    return fallback
  }
}
